import { UserException } from '@/domain/user/exception/UserException'

export class InvalidCountryIdException extends UserException {

}
